import { Download } from 'lucide-react';

export default function TableExportButton({
  handleExport,
  isLoadingMutate,
}: {
  handleExport?: () => void;
  isLoadingMutate?: boolean;
}) {
  return (
    <button
      className="flex flex-row rounded-lg items-center align-middle border py-2 px-[15px] text-white bg-primary cursor-pointer text-sm disabled:opacity-50 disabled:pointer-events-none"
      onClick={handleExport}
      disabled={isLoadingMutate}
    >
      <Download size={14} className="mr-1" />
      Export to excel
    </button>
  );
}
